/**
 * VENDOR BUNDLE
 *
 * This file bundles all third-party libraries that are used across ALL pages.
 * Benefits:
 * - Cached once, used everywhere
 * - Better compression (libraries have common patterns)
 * - Reduces redundant parsing/compilation
 * - Content-hashed for cache busting
 *
 * Libraries included:
 * - jQuery 3.7.1 (used on every page)
 * - Bootstrap 5.3.3 (used on every page)
 *
 * Note: Chart.js is NOT included here since it's only used on the inventory page.
 * It's bundled separately in charts.js to avoid loading it on every page.
 */

// ============================================================================
// jQuery - Make available globally
// ============================================================================
import $ from 'jquery';
(globalThis as any).$ = $;
(globalThis as any).jQuery = $;

// ============================================================================
// Bootstrap - Requires jQuery and Popper.js (bundled)
// ============================================================================
import * as bootstrap from 'bootstrap';
(globalThis as any).bootstrap = bootstrap;

// ============================================================================
// Export for type safety (optional)
// ============================================================================
export { $ } from 'jquery';
export * as bootstrap from 'bootstrap';
